import {
    NavContainer,
    IconTextMoonContainer,
    MobileIcon,
    SpanOne,
    SpanThree,
    SpanTwo,
    BurgerCheckHolder,
    FakeCheckBox,
    Card,
    CardItem,
} from "./NavStyled";
import { useEffect, useRef, useState } from "react";
import LiquibotIcon from "../../Icons/liquiboticonweb.png";
import { MoonIcon } from "./MoonIcon";

export const menuOptions = ["Landing", "Conversation", "Footer"];
export const ids = [
    "landing-container",
    "conversation-container",
    "footer-container",
];

export const MobileMenu = () => {
    const [clicked, setClicked] = useState<boolean>(false);
    const [translateNavBar, setTranslateNavBar] = useState<boolean>(false);
    const scrollTo = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    };
    const previousScrollValue = useRef<number>(window.scrollY);
    const handleScroll = () => {
        setTranslateNavBar(window.scrollY > previousScrollValue.current);
        if (
            window.scrollY > previousScrollValue.current &&
            window.scrollY - previousScrollValue.current > 20
        ) {
            setTranslateNavBar(true);
        } else if (
            window.scrollY <= previousScrollValue.current &&
            previousScrollValue.current - window.scrollY > 20
        ) {
            setTranslateNavBar(false);
        }
        previousScrollValue.current = window.scrollY;
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <NavContainer $show={translateNavBar}>
            <IconTextMoonContainer>
                <MobileIcon src={LiquibotIcon} />
                <MoonIcon />
            </IconTextMoonContainer>
            <BurgerCheckHolder>
                <FakeCheckBox
                    type="checkbox"
                    onClick={() => setClicked(!clicked)}
                    $active={clicked}
                />
                <SpanOne $active={clicked} />
                <SpanTwo $active={clicked} />
                <SpanThree $active={clicked} />
            </BurgerCheckHolder>
            <Card $active={clicked}>
                {menuOptions.map((option, idx) => {
                    return (
                        <CardItem
                            key={idx}
                            onClick={() => {
                                scrollTo(ids[idx]);
                                setClicked(!clicked);
                            }}
                        >
                            {option}
                        </CardItem>
                    );
                })}
            </Card>
        </NavContainer>
    );
};
